<template>
  <div id="contents" class="service-intro">
    <div class="inner">
      <h3 class="main-title">서비스소개</h3>
      <ul class="tab-wrap">
        <li><a href="/service/hometown" class="tab-btn">SKB 우리동네광고</a></li>
        <li><a href="/service/skylife" class="tab-btn active">KT스카이라이프 IPTV광고</a></li>
        <li><a href="/service/experience" class="tab-btn">체험단 마케팅</a></li>
        <li><a href="/service/reporter" class="tab-btn">기자단 마케팅</a></li>
        <li><a href="/service/insta" class="tab-btn">인스타 마케팅</a></li>
        <li><a href="/service/viral" class="tab-btn">바이럴 마케팅</a></li>
      </ul>
    </div>
    <div class="service-intro-wrap">
      <section class="sec01">
        <div class="inner flexbox">
          <div class="title-wrap">
            <h4 class="section-title">1300만 가입자 보유한<br/>소상공인 전용 우리가게 TV광고</h4>
            <p class="section-desc">저렴한 비용으로 전국 TV광고를 할 수 있는 소상공인 전용 광고 상품입니다.<br/>
              동 단위의 지역 타겟팅이 가능하여 원하는 지역만 선택해 광고할 수 있습니다.</p>
          </div>
          <img src="../resource/images/service-skylife-logo.png" alt="kt skylife"/>
        </div>
      </section>
      <section class="sec02">
        <div class="inner">
          <ul class="list type-btn">
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro05.png" alt=""/>
                  소상공인을 위한&nbsp;<span class="tx-blue">맞춤 패키지 상품 보유</span>
                </span>
            </li>
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro06.png" alt=""/>
                  꾸준하고 반복적인 콘텐츠 노출로&nbsp;<span class="tx-blue">브랜드 인지도 상승 효과</span>
                </span>
            </li>
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro07.png" alt=""/>
                  <span class="tx-blue">원하는 지역</span>만 콕 집어 진행하는 타겟 TV 광고
                </span>
            </li>
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro08.png" alt=""/>
                  실제 방문 가망고객이 있는 지역 타겟 광고로&nbsp;
                  <span class="tx-blue">확실한 효과</span>&nbsp;기대
                </span>
            </li>
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro09.png" alt=""/>
                  <span class="tx-blue">전체 100개 채널</span>&nbsp; 광고 or&nbsp;
                  <span class="tx-blue">상위 30개 채널</span>&nbsp;선택 가능
                </span>
            </li>
          </ul>
        </div>
      </section>
      <section class="sec03">
        <div class="inner">
          <ul class="info-list-line">
            <li>
              <h4 class="info-title">대한민국  70% 가입자 보유</h4>
              <p class="section-desc">skylife와  HCN, KT가 하나로 뭉쳐 더욱 강력해진  KT skylife 매체를 통해 수도권부터 광역시까지 시/군/구 단위로 지역 TV광고를 집행할 수 있습니다.</p>
            </li>
            <li>
              <h4 class="info-title">소비 트랜드의 중심 20~50세대 주요 사용자 </h4>
              <p class="section-desc">월 소득, 소비가 높은 20~50 세대가 주요 사용자로 차지하고 있는 KT skylife를 통해 실제 방문할만한 가망 고객에게 광고를 노출해보세요.</p>
            </li>
            <li>
              <h4 class="info-title">소상공인 전용 TV 광고 상품</h4>
              <p class="section-desc">짧은 기간으로도 매출 상승의 효과를 기대할 수 있는 지역 TV광고, 소상공인이 라면 할인가로 저렴한 가격에 광고를 진행할 수 있습니다</p>
            </li>
          </ul>
        </div>
      </section>
      <section class="sec04">
        <div class="inner small">
          <h4 class="section-sub-title">샘플 영상</h4>
          <div class="video">
            <video controls style="width:100%; height:100%; ">
              <source src="../resource/data/kt.mp4" type="video/mp4"/>
            </video>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>

export default {
  name: 'page-notice',
  components: {

  },
  data () {
    return {
      curWidth: 2.5
    }
  },
  mounted() {
    if (document.body.clientWidth < 800) {
      this.curWidth = 1
    }
    document.body.classList.add('sub');
    this.scroll();
  },
  methods: {
    scroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || window.screenY;
      document.querySelectorAll("section").forEach(item => {
        if(scrollTop > item.offsetTop - window.innerHeight / this.curWidth){
          item.classList.add("on");
        }
      });
      window.requestAnimationFrame(this.scroll);
    }
  }
}

</script>